import { ComplianceNoteEffects } from 'src/app/compliance/store/effects/compliance-note.effects';
import { CompliancePermissionsEffects } from 'src/app/compliance/store/effects/compliance-permissions.effects';
import { ComplianceReportEffects } from 'src/app/compliance/store/effects/compliance-report.effects';
import { ComplianceRoutingEffects } from 'src/app/compliance/store/effects/compliance-routing.effects';
import { CredentialingSpecialistsEffects } from 'src/app/compliance/store/effects/credentialing-specialists.effects';
import { DocumentBatchDetailsEffects } from 'src/app/compliance/store/effects/document-batch-details.effects';
import { DocumentDetailsEffect } from 'src/app/compliance/store/effects/document-details.effects';
import { DocumentTypesEffects } from 'src/app/compliance/store/effects/document-types.effects';
import { DocumentUploadEffects } from 'src/app/compliance/store/effects/document-upload.effects';
import { DocumentEffects } from 'src/app/compliance/store/effects/document.effects';
import { FacilitiesEffects } from 'src/app/compliance/store/effects/facilities.effects';
import { StateLicensureEffects } from 'src/app/compliance/store/effects/state-licensure.effects';
import { ComplianceLiaisonsEffects } from './compliance-liaisons.effects';
import { ComplianceRequestsEffects } from './compliance-requests.effects';
import { MetadataConfigurationEffects } from './metadata-configuration.effects';
import { ComplianceRequirementDescriptionsEffects } from './compliance-requirement-descriptions.effects';
import { ContractEffects } from './contract.effects';
import { MatchGroupEffects } from './match-group.effects';
import { ProfessionSpecialtyConfigurationEffects } from './profession-specialty-configuration.effects';
import { QmAssociationsEffects } from './qm-associations.effects';
import { ScheduleOrientationEffects } from './schedule-orientation.effects';
import { ShippingRequestsEffects } from './shipping-requests.effects';
import { StateRequirementEffects } from './state-requirement.effects';
import { ValQueueEffects } from './val-queue.effects';
import { RequirementOverrideEffects } from './requirement-override.effects';
import { ComplianceLabEffects } from './compliance-lab.effects';
import { ComplianceReportNewEffects } from './compliance-report-new.effects';
import { ComplianceMetadataEffects } from './compliance-metadata.effects';

export const complianceEffects = [
    ContractEffects,
    DocumentDetailsEffect,
    DocumentEffects,
    DocumentTypesEffects,
    DocumentUploadEffects,
    DocumentBatchDetailsEffects,
    ComplianceRoutingEffects,
    ComplianceNoteEffects,
    ComplianceReportEffects,
    MetadataConfigurationEffects,
    MatchGroupEffects,
    CompliancePermissionsEffects,
    CredentialingSpecialistsEffects,
    FacilitiesEffects,
    QmAssociationsEffects,
    StateLicensureEffects,
    StateRequirementEffects,
    ShippingRequestsEffects,
    ComplianceLiaisonsEffects,
    ComplianceRequestsEffects,
    ValQueueEffects,
    ScheduleOrientationEffects,
    ComplianceRequirementDescriptionsEffects,
    ProfessionSpecialtyConfigurationEffects,
    RequirementOverrideEffects,
    ComplianceLabEffects,
    ComplianceReportNewEffects,
    ComplianceMetadataEffects
];
